import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import contactsServices from '@src/services/contacts.services';

export const getContactInfo = createAsyncThunk('getUserInfo', async (body, { rejectWithValue }) => {
  try {
    const response = await contactsServices.getContactInfo(body);
    return response;
  } catch (error) {
    return rejectWithValue(error?.data);
  }
});

const initialState = {
  contactInfo: {},
};

export const contactsSlice = createSlice({
  name: 'contacts',
  initialState,
  reducers: {
    resetContactInfo(state) {
      state.contactInfo = {};
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getContactInfo.fulfilled, (state, action) => {
      state.contactInfo = action?.payload?.data[0];
    });
  },
});

export const { resetContactInfo } = contactsSlice.actions;
